// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.country-map-container {
  margin-bottom: 20px;
}

.country-map-wrapper {
  display: flex;
  gap: 20px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 15px;
  border: 1px solid #e5e7eb;
}

.country-map-chart {
  flex: 1 1;
  height: 420px;
  position: relative;
  min-width: 0;
  overflow: hidden;
  cursor: grab;
}

.country-map-chart:active {
  cursor: grabbing;
}

/* Map zoom controls */
.map-controls {
  position: absolute;
  bottom: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 10;
}

.map-control-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  background: white;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.map-control-btn:hover {
  background: #f5f5f5;
  border-color: #d1d5db;
  color: #333;
}

.map-control-btn:active {
  background: #e5e7eb;
}

.map-reset-btn {
  font-size: 16px;
  margin-top: 4px;
}

.country-map-legend {
  width: 280px;
  min-width: 280px;
  flex-shrink: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.legend-title {
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  font-size: 14px;
}

.legend-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 320px;
  padding-right: 5px;
  padding-left: 3px;
}

/* Scrollbar styling for legend */
.legend-items::-webkit-scrollbar {
  width: 6px;
}

.legend-items::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.legend-items::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.legend-items::-webkit-scrollbar-thumb:hover {
  background: #aaa;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-left: 3px solid transparent;
}

.legend-item:hover {
  background-color: #f5f5f5;
}

.legend-item-highlighted {
  background-color: #f0e6ff !important;
}

.legend-item-selected {
  background-color: #e8dcff !important;
  border-left-color: #5616ea;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  flex-shrink: 0;
}

.legend-country {
  flex: 1 1;
  font-size: 13px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
}

.legend-count {
  font-weight: 600;
  font-size: 13px;
  color: #5616ea;
  min-width: 30px;
  text-align: right;
}

.legend-item-unknown {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e5e7eb;
}

.legend-item-unknown .legend-count {
  color: #888;
}

.legend-empty {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  padding: 0;
  color: #888;
  font-size: 13px;
}

.legend-empty p {
  margin: 0;
}

.legend-empty .no-ip-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #aaa;
}

.legend-total {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e5e7eb;
  font-weight: 600;
  font-size: 14px;
  color: #333;
}

.country-map-tooltip {
  position: fixed;
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  pointer-events: none;
  z-index: 1000;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.country-map-loading,
.country-map-empty {
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 40px;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.country-map-loading .loading-spinner {
  font-size: 24px;
  color: #5616ea;
}

.country-map-empty p {
  color: #888;
  font-size: 14px;
  margin: 0;
}

.country-map-empty .no-ip-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #aaa;
}

.spinner-small {
  width: 30px;
  height: 30px;
  border: 3px solid #e5e7eb;
  border-top-color: #5616ea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments */
@media (max-width: 900px) {
  .country-map-wrapper {
    flex-direction: column;
  }

  .country-map-legend {
    width: 100%;
    min-width: unset;
    padding: 15px 0 0 0;
    border-top: 1px solid #e5e7eb;
  }

  .legend-title {
    margin-bottom: 10px;
  }

  .legend-items {
    flex-direction: column;
    max-height: 200px;
    overflow-y: auto;
    gap: 8px;
  }

  .legend-item {
    min-width: unset;
  }

  .legend-total {
    margin-top: 10px;
    padding-top: 10px;
  }
}

@media (max-width: 600px) {
  .country-map-chart {
    height: 280px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/countryDistributionMap.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".country-map-container {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.country-map-wrapper {\r\n  display: flex;\r\n  gap: 20px;\r\n  background-color: rgb(255, 255, 255);\r\n  border-radius: 10px;\r\n  padding: 15px;\r\n  border: 1px solid #e5e7eb;\r\n}\r\n\r\n.country-map-chart {\r\n  flex: 1;\r\n  height: 420px;\r\n  position: relative;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  cursor: grab;\r\n}\r\n\r\n.country-map-chart:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n/* Map zoom controls */\r\n.map-controls {\r\n  position: absolute;\r\n  bottom: 10px;\r\n  right: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  z-index: 10;\r\n}\r\n\r\n.map-control-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 1px solid #e5e7eb;\r\n  background: white;\r\n  border-radius: 6px;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  color: #555;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.15s ease;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.map-control-btn:hover {\r\n  background: #f5f5f5;\r\n  border-color: #d1d5db;\r\n  color: #333;\r\n}\r\n\r\n.map-control-btn:active {\r\n  background: #e5e7eb;\r\n}\r\n\r\n.map-reset-btn {\r\n  font-size: 16px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.country-map-legend {\r\n  width: 280px;\r\n  min-width: 280px;\r\n  flex-shrink: 0;\r\n  padding: 10px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.legend-title {\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 15px;\r\n  font-size: 14px;\r\n}\r\n\r\n.legend-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  max-height: 320px;\r\n  padding-right: 5px;\r\n  padding-left: 3px;\r\n}\r\n\r\n/* Scrollbar styling for legend */\r\n.legend-items::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.legend-items::-webkit-scrollbar-track {\r\n  background: #f5f5f5;\r\n  border-radius: 3px;\r\n}\r\n\r\n.legend-items::-webkit-scrollbar-thumb {\r\n  background: #ccc;\r\n  border-radius: 3px;\r\n}\r\n\r\n.legend-items::-webkit-scrollbar-thumb:hover {\r\n  background: #aaa;\r\n}\r\n\r\n.legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 6px 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease;\r\n  border-left: 3px solid transparent;\r\n}\r\n\r\n.legend-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.legend-item-highlighted {\r\n  background-color: #f0e6ff !important;\r\n}\r\n\r\n.legend-item-selected {\r\n  background-color: #e8dcff !important;\r\n  border-left-color: #5616ea;\r\n}\r\n\r\n.legend-color {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.legend-country {\r\n  flex: 1;\r\n  font-size: 13px;\r\n  color: #555;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 180px;\r\n}\r\n\r\n.legend-count {\r\n  font-weight: 600;\r\n  font-size: 13px;\r\n  color: #5616ea;\r\n  min-width: 30px;\r\n  text-align: right;\r\n}\r\n\r\n.legend-item-unknown {\r\n  margin-top: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px dashed #e5e7eb;\r\n}\r\n\r\n.legend-item-unknown .legend-count {\r\n  color: #888;\r\n}\r\n\r\n.legend-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n  text-align: left;\r\n  padding: 0;\r\n  color: #888;\r\n  font-size: 13px;\r\n}\r\n\r\n.legend-empty p {\r\n  margin: 0;\r\n}\r\n\r\n.legend-empty .no-ip-hint {\r\n  margin-top: 8px;\r\n  font-size: 12px;\r\n  color: #aaa;\r\n}\r\n\r\n.legend-total {\r\n  margin-top: 15px;\r\n  padding-top: 15px;\r\n  border-top: 1px solid #e5e7eb;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #333;\r\n}\r\n\r\n.country-map-tooltip {\r\n  position: fixed;\r\n  background: rgba(0, 0, 0, 0.85);\r\n  color: white;\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  pointer-events: none;\r\n  z-index: 1000;\r\n  white-space: nowrap;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.country-map-loading,\r\n.country-map-empty {\r\n  background-color: rgb(255, 255, 255);\r\n  border-radius: 10px;\r\n  padding: 40px;\r\n  border: 1px solid #e5e7eb;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 200px;\r\n}\r\n\r\n.country-map-loading .loading-spinner {\r\n  font-size: 24px;\r\n  color: #5616ea;\r\n}\r\n\r\n.country-map-empty p {\r\n  color: #888;\r\n  font-size: 14px;\r\n  margin: 0;\r\n}\r\n\r\n.country-map-empty .no-ip-hint {\r\n  margin-top: 8px;\r\n  font-size: 12px;\r\n  color: #aaa;\r\n}\r\n\r\n.spinner-small {\r\n  width: 30px;\r\n  height: 30px;\r\n  border: 3px solid #e5e7eb;\r\n  border-top-color: #5616ea;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 900px) {\r\n  .country-map-wrapper {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .country-map-legend {\r\n    width: 100%;\r\n    min-width: unset;\r\n    padding: 15px 0 0 0;\r\n    border-top: 1px solid #e5e7eb;\r\n  }\r\n\r\n  .legend-title {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .legend-items {\r\n    flex-direction: column;\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    gap: 8px;\r\n  }\r\n\r\n  .legend-item {\r\n    min-width: unset;\r\n  }\r\n\r\n  .legend-total {\r\n    margin-top: 10px;\r\n    padding-top: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .country-map-chart {\r\n    height: 280px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
